(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("theme", [], factory);
	else if(typeof exports === 'object')
		exports["theme"] = factory();
	else
		root["theme"] = factory();
})(this, function() {
return 